module.exports = __webpack_public_path__ + "static/media/LTW-Global.6bdd3d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/logos/LTW-Global.png
// module id = 930
// module chunks = 0